(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('AddExaminersDialogController', AddExaminersDialogController);

    function AddExaminersDialogController(logger, $uibModalInstance, $translate, $window, activity) {
        var vm = this;

        vm.activity = activity;
        vm.examiners = [];

        vm.addExaminer = addExaminer;
        vm.cancel = cancel;
        vm.ok = ok;
        vm.removeExaminer = removeExaminer;

        function addExaminer(identity) {
            var existing = _.find(vm.examiners, { idString: identity.idString });
            if (existing) return;
            vm.examiners.push({ idString: identity.idString, name: identity.displayName });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
        
        function ok() {
            $uibModalInstance.close(vm.examiners);
        }

        function removeExaminer(identity) {
            var idx = vm.examiners.indexOf(identity);
            vm.examiners.splice(idx, 1);
        }
    }
})();
